import { lazy } from "react";
import { Navigate, Outlet, useRoutes } from "react-router-dom";

import { useAppState } from "./context";
import Auth from "./views/Auth/Index";
import CurrentWeekSetting from "./views/CurrentWeekSetting";
import FocusMember from "./views/FocusMember";
import Home from "./views/Home";
import PageNotFound from "./views/PageNotFound";
import Profile from "./views/Profile";
import UploadFile from "./views/UploadDoc/Index";

const Dashboard = lazy(() => import("./views/Dashboard/DashboardComponent"));
const UserVerification = lazy(() => import("./views/UserVerification"));
const User = lazy(() => import("./views/User"));

const UnAuthorizedAccess = lazy(() => import("./views/UnAuthorizedAccess"));
const TeamMember = lazy(() => import("./views/TeamMember/createMember"));
const EditTeamMember = lazy(() => import("./views/TeamMember/editMember"));
const TeamMemberList = lazy(() => import("./views/TeamMember/index"));

export const PrivateRoute = ({ children }: { children: any }) => {
  const { isLoggedIn } = useAppState("auth");

  return isLoggedIn ? children : <Navigate to="/unauthorized" />;
};
const RouteWrapper = ({ element }: { element: any }) => {
  const { isLoggedIn } = useAppState("auth");

  return isLoggedIn ? element : <Navigate to="/unauthorized" />;
};

const Routing = () => {
  const { userData } = useAppState("auth");
  const { isLoggedIn, getLatestToken } = useAppState("auth");
  const { accessToken } = getLatestToken();

  const validLogin = accessToken && isLoggedIn;

  const routes = useRoutes([
    {
      path: "/",
      element: validLogin ? <Navigate to="/dashboard" /> : <Auth />,
      caseSensitive: true,
    },

    {
      path: "/user-verification/:id",
      element: <UserVerification />,
      caseSensitive: true,
    },
    {
      path: "/",
      element: <RouteWrapper element={<Outlet />} />,
      children: [
        {
          path: "/user",
          element: <User />,
          caseSensitive: true,
        },
        {
          path: "/home",
          element: <Home />,
          caseSensitive: true,
        },
      ],
    },
    {
      path: "/profile",
      element: <Profile />,
      caseSensitive: true,
    },
    {
      path: "/focusmember",
      element: userData?.is_admin ? <FocusMember /> : <UnAuthorizedAccess />,
      caseSensitive: true,
    },
    {
      path: "/week-setting",
      element: userData?.is_admin ? (
        <CurrentWeekSetting />
      ) : (
        <UnAuthorizedAccess />
      ),
      caseSensitive: true,
    },
    {
      path: "/upload-doc",
      element: userData?.is_admin ? <UploadFile /> : <UnAuthorizedAccess />,
      caseSensitive: true,
    },
    {
      path: "/member/create",
      element: <TeamMember />,
      caseSensitive: true,
    },
    {
      path: "/member/edit",
      element: <EditTeamMember />,
      caseSensitive: true,
    },
    {
      path: "/member",
      element: <TeamMemberList />,
      caseSensitive: true,
    },
    {
      path: "/dashboard",
      element: validLogin ? <Dashboard /> : <Navigate to="/login" />,
      caseSensitive: true,
    },
    {
      path: "/login",
      element: validLogin ? <Navigate to="/dashboard" /> : <Auth />,
      caseSensitive: true,
    },
    {
      path: "/register",
      element: <Auth />,
      caseSensitive: true,
    },
    {
      path: "unauthorized",
      element: <UnAuthorizedAccess />,
      caseSensitive: true,
    },
    {
      path: "/*",
      element: <PageNotFound />,
    },
  ]);

  return routes;
};

export default Routing;
